import { FlightInfo } from './../shared/flight-info';
import {
  CarDetail,
  CarRateCodeFee,
  CheckPriceData,
  TermsAndCondition
} from './car-detail';

export enum ReservationStatus {
  Unknown,
  Created,
  Paid,
  Cancelled
}

export interface UserDetails {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface ServiceOutcome {
  success: boolean;
  errorCode: string;
  errorMessage: string;
}

export interface CancelSummary {
  card: ServiceOutcome;
  vc: ServiceOutcome;
  dbc: ServiceOutcome;
  arriviaLoyaltyEarn: ServiceOutcome;
  arriviaLoyaltyBurn: ServiceOutcome;
}

export interface Insurance {
  policyNumber: string;
  status: string;
}

export interface ReservationDetail {
  bookingReferenceNumber: string;
  bookingStatus: string;
  status: ReservationStatus;
  bookingId: string;
  confirmationId: string;
  userDetails: UserDetails;
  pickupDateTime: Date;
  dropOffDateTime: Date;
  vehicle: CarDetail;
  pricingSummary: CheckPriceData;
  termsAndConditions: TermsAndCondition[];
  flightInfo: FlightInfo;
  isCancelable: boolean;
  cancelSummary: CancelSummary;
  insurance: Insurance;
}

